exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-Map-___Map__controls___3bLtr{position:absolute;top:10px;right:10px}.src-components-Map-___Map__icon___3hKOY:hover{fill:#1e88e5!important}.src-components-Map-___Map__mapFooter___wGQpD:after{visibility:hidden;display:block;font-size:0;content:\" \";clear:both;height:0}.src-components-Map-___Map__legend___2NbTJ{float:right}@media only screen and (max-width:500px){.src-components-Map-___Map__icon___3hKOY{width:36px!important;height:36px!important}}.map-info-window .heading{margin-bottom:8px;min-height:24px}.map-info-window svg{margin-right:5px;vertical-align:top!important}.map-info-window h4{margin:0;font-weight:500!important;color:rgba(0,0,0,.87)!important;font-size:14px!important;display:inline-block;vertical-align:top;line-height:24px}.map-info-window p{font-size:13px!important;margin:.5em 0!important}.map-info-window:not(:last-of-type){margin-bottom:15px}", ""]);

// exports
exports.locals = {
	"controls": "src-components-Map-___Map__controls___3bLtr",
	"icon": "src-components-Map-___Map__icon___3hKOY",
	"mapFooter": "src-components-Map-___Map__mapFooter___wGQpD",
	"legend": "src-components-Map-___Map__legend___2NbTJ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./src/components/Map/Map.css
// module id = 476
// module chunks = 0